import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class ChangeOrCancelApi {
  /**
   * 受付トランの検索（WEB窓口開始ページURLで検索）
   * @param {*} startUrl
   * @returns
   */
  findByChangeUrl = async (startUrl = null) => {
    const filter = { 'reserve.change_url': startUrl, enable: true };
    const params = { filter };
    const response = await requestManager.get(
      `${API_PATH}/changeOrCancel/r/initial-search-reception`,
      params
    );

    return response.data;
  };

  findByUsePlaceId = async (usePlaceId = null) => {
    const filter = { place_id: usePlaceId, enable: true };
    const params = { filter };
    const response = await requestManager.get(
      `${API_PATH}/changeOrCancel/r/initial-search-place`,
      params
    );

    return response.data;
  };

  /**
   * 予約設定マスタ検索
   * @param {number} rsvSetId 予約設定ID
   * @returns {int} 予約設定
   */
  searchReserveSetting = async (rsvSetId = null) => {
    const filter = { rsv_set_id: rsvSetId, enable: true };
    const params = { filter };
    const result = await requestManager.get(
      `${API_PATH}/changeOrCancel/r/initial-search-rsv-setting`,
      params
    );
    return result.data;
  };
}

export default new ChangeOrCancelApi();
